import SectionTitle from "../../../components/section-title";
import AppointmentForm from "../../../components/appointment-form";

const AppointmentContainer = () => {
    return (
        <section className="appointment-area bg-gray" id="appointment">
            <div className="appointment-form-style1">
                <div className="container">
                    <div className="appointment-form">
                        <SectionTitle subTitle="상담 예약 안내" title="<span>시술 상담</span> 예약하기" />
                        <AppointmentForm />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AppointmentContainer;
